import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

const FullWidthScribbleLine = () => {
  const pathRef = useRef(null);

  useGSAP(() => {
    const path = pathRef.current;
    if (path) {
      const length = path.getTotalLength();
      gsap.set(path, {
        strokeDasharray: length,
        strokeDashoffset: length,
      });
      gsap.to(path, {
        strokeDashoffset: 0,
        duration: 6,
        repeat: -1,
        ease: "power1.inOut",
        yoyo: true,
      });
    }
  }, []);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={"100%"}

      fill="none"
      viewBox="0 0 1835 383"
    >
      <path
        ref={pathRef}
        stroke="#A5D246"
        strokeWidth={12}
        d="M3.535 95.467C174.093-11.166 93.55 426.723 14.947 316.913c-62.88-87.847 239.5 27 387-230s117.003 187.02 231 179.5c113.997-7.52 87.122-208.054 205.5-229.5C956.825 15.468 933.419 264.22 1082.42 247.72c149-16.5 155.16-157.54 265-170 46.76-5.304 87.41 36.589 118.69 86.456"
      />
    </svg>
  );
};
export default FullWidthScribbleLine;
